import React, {
  InputHTMLAttributes,
  useEffect,
  useMemo,
  useRef,
  useContext,
} from 'react'
import { FormikContext, FormikContextType, getIn } from 'formik'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string
  type?: 'hidden'
}

type FormikValues = Record<string, unknown>

const InputHidden: React.FC<Props> = ({
  name,
  type = 'hidden',
  value: valueProp,
  defaultValue,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const formik = useContext(FormikContext) as
    | FormikContextType<FormikValues>
    | undefined
  const isFormik = !!formik

  const formikValue = useMemo(() => {
    if (!isFormik) return undefined
    return getIn(formik.values, name) as unknown
  }, [formik, isFormik, name])

  useEffect(() => {
    if (!isFormik) return
    if (valueProp !== undefined) {
      formik.setFieldValue(name, valueProp, false)
    } else if (defaultValue !== undefined && formikValue === undefined) {
      formik.setFieldValue(name, defaultValue, false)
    }
  }, [isFormik, name, valueProp, defaultValue])

  const inputValue = isFormik ? (formikValue ?? '') : valueProp

  return (
    <input
      ref={inputRef}
      name={name}
      type={type}
      {...(isFormik || valueProp !== undefined
        ? { value: String(inputValue ?? '') }
        : { defaultValue })}
      {...rest}
    />
  )
}

export default InputHidden
